import { jobsApi } from "../services/api";

// Waits for a field-suggestion job and resolves with its result_data.
// onProgress receives { percent, message } while it runs.
export function waitForSuggestionJob(jobId, { onProgress, intervalMs = 3000, timeoutMs = 8 * 60 * 1000 } = {}) {
  const started = Date.now();
  return new Promise((resolve, reject) => {
    const check = async () => {
      try {
        const { data: job } = await jobsApi.getStatus(jobId);
        if (job.status === "completed") {
          const data = typeof job.result_data === "string" ? JSON.parse(job.result_data) : job.result_data;
          resolve({ ...(data || {}), job_id: jobId });
          return;
        }
        if (job.status === "failed") {
          reject(new Error(job.error_message || "The AI suggestion failed."));
          return;
        }
        onProgress?.({ percent: job.progress_percent || 0, message: job.progress_message || "Processing…" });
        if (Date.now() - started > timeoutMs) {
          reject(new Error("The AI suggestion is taking too long. Please try again."));
          return;
        }
        setTimeout(check, intervalMs);
      } catch (e) {
        reject(e);
      }
    };
    check();
  });
}
